import React from 'react'

/**
 * Figma publish toggle (mock `.tgl-row` / `.tgl-k`) — 50x28 pill, 22px white knob
 * 3px in; ink track when on, #dbdadf when off, the label always ink. Shared by the
 * event-dashboard bar (Figma 3790:24988), the per-workout publish switch (Figma
 * 3790:20810), the reviews Private / Public switch and the album editor.
 *
 * `labelClassName` lets a caller reserve width for the label so the knob does not
 * jump when the wording changes ("Unpublished" → "Published").
 */
export default function EventHubPublishToggle({
    label,
    checked,
    disabled,
    onChange,
    className = '',
    labelClassName = '',
    'aria-label': ariaLabel,
}) {
    return (
        <label
            className={`flex shrink-0 items-center gap-2.5 whitespace-nowrap text-sm text-[#272727] ${
                disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
            } ${className}`}
        >
            <span className={labelClassName}>{label}</span>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={ariaLabel}
                disabled={disabled}
                onClick={() => onChange(!checked)}
                className={`s-focus-ring flex h-7 w-12.5 shrink-0 items-center rounded-full border-0 px-0.75 transition-colors ${
                    checked ? 'justify-end bg-[#272727]' : 'bg-[#dbdadf]'
                } ${disabled ? '' : 'cursor-pointer'}`}
            >
                <span className="size-5.5 rounded-full bg-white transition-transform" />
            </button>
        </label>
    )
}
